document.addEventListener('change', (event) => {
  if (event.target.matches('[data-sc-market]')) event.target.form?.submit();
});

document.addEventListener('click', (event) => {
  if (!event.target.closest('.sc-mobile-menu a')) return;
  event.target.closest('.sc-mobile-menu')?.removeAttribute('open');
});

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('[data-sc-newsletter-success]')) document.documentElement.classList.add('sc-newsletter-success-page');
});

const productCardHoverMedia = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
const productCardHoverStates = new WeakMap();

function resetProductCardHover(state) {
  state.generation += 1;
  state.source = '';
  state.pending = false;
  state.link.classList.remove('is-secondary-ready');
}

function checkProductCardHover(state) {
  const image = state.image;
  const source = image.currentSrc;
  if (!productCardHoverMedia.matches || !image.complete || !source || source.startsWith('data:') || image.naturalWidth < 2) {
    resetProductCardHover(state);
    return;
  }
  if (state.source === source && (state.pending || state.link.classList.contains('is-secondary-ready'))) return;

  resetProductCardHover(state);
  state.source = source;
  state.pending = true;
  const generation = state.generation;
  const reveal = () => {
    if (state.generation !== generation) return;
    state.pending = false;
    if (productCardHoverMedia.matches && image.complete && image.currentSrc === source && image.naturalWidth > 1) {
      state.link.classList.add('is-secondary-ready');
    } else {
      resetProductCardHover(state);
    }
  };
  if (typeof image.decode === 'function') {
    image.decode().then(reveal).catch(() => {
      if (state.generation === generation) resetProductCardHover(state);
    });
  } else {
    reveal();
  }
}

document.addEventListener('pointerover', (event) => {
  if (!productCardHoverMedia.matches) return;
  const imageLink = event.target.closest('.sc-product-image');
  if (!imageLink || imageLink.contains(event.relatedTarget)) return;
  const secondaryImage = imageLink.querySelector('.sc-product-image__secondary');
  if (!secondaryImage) return;

  let state = productCardHoverStates.get(imageLink);
  if (!state) {
    state = { link: imageLink, image: secondaryImage, generation: 0, source: '', pending: false };
    productCardHoverStates.set(imageLink, state);
    secondaryImage.addEventListener('load', () => checkProductCardHover(state));
    secondaryImage.addEventListener('error', () => resetProductCardHover(state));
  }
  checkProductCardHover(state);
});

productCardHoverMedia.addEventListener('change', () => {
  document.querySelectorAll('.sc-product-image').forEach((imageLink) => {
    const state = productCardHoverStates.get(imageLink);
    if (!state) return;
    resetProductCardHover(state);
    if (productCardHoverMedia.matches) checkProductCardHover(state);
  });
});
